"use client";

import config from "@/app.config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, IconButton, Skeleton } from "@mui/material";
import { StoreType } from "@/types/store.type";
import CallRoundedIcon from "@mui/icons-material/CallRounded";

export default function Stores() {
  const [loading, setLoading] = useState(true);
  const [stores, setStores] = useState<StoreType[]>([]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          `${config.app.apiBaseUrl}/api/v2/stores`,
        );

        setStores(response.data.data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <section className="py-4 max-w-8xl mx-auto px-4">
        <h4 className="text-center font-semibold text-xl md:text-4xl mb-2 md:mb-4">
          Our Stores
        </h4>

        <Swiper spaceBetween={12} slidesPerView="auto" loop>
          {[1, 2, 3, 4, 5].map((_, index) => (
            <SwiperSlide key={index} className="md:max-w-1/4 pb-4">
              <div className="block shadow-sm hover:shadow-lg duration-500">
                <Card>
                  <CardContent>
                    <div className="flex gap-2 flex-nowrap items-center justify-between">
                      <div className="space-y-2">
                        <Skeleton width={200} variant="rounded" />
                        <Skeleton width={150} variant="rounded" />
                      </div>
                      <Skeleton width={36} height={36} variant="circular" />
                    </div>
                    <p className="text-sm mt-3 h-[60px] space-y-2">
                      <Skeleton variant="rounded" />
                      <Skeleton variant="rounded" />
                      <Skeleton variant="rounded" width={200} />
                    </p>
                  </CardContent>
                </Card>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    );
  }

  if (stores.length == 0) return null;

  return (
    <section className="py-4 max-w-8xl mx-auto px-4">
      <h4 className="text-center font-semibold text-xl md:text-4xl mb-2 md:mb-4">
        Our Stores
      </h4>

      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        spaceBetween={12}
        slidesPerView="auto"
        loop
      >
        {stores
          .filter((v) => !v.location.includes("Bengaluru"))
          .map((store, index) => (
            <SwiperSlide key={index} className="md:max-w-1/4 pb-4">
              <div className="block shadow-sm hover:shadow-lg duration-500">
                <Card>
                  <CardContent>
                    <div className="flex gap-2 flex-nowrap items-center justify-between">
                      <div>
                        <div className="font-semibold text-lg leading-none">
                          {store.location}
                        </div>
                        <div>{store.phone}</div>
                      </div>
                      <IconButton
                        aria-label={`Call ${store.location} at ${store.phone}`}
                        href={`tel:${store.phone}`}
                        size="small"
                        sx={{
                          backgroundColor: (theme) =>
                            theme.palette.primary.main,
                          color: "#fff",
                          "&:hover": {
                            backgroundColor: (theme) =>
                              theme.palette.primary.dark,
                          },
                        }}
                      >
                        <CallRoundedIcon fontSize="small" />
                      </IconButton>
                    </div>
                    <p className="text-sm mt-2 h-[60px]">{store.address}</p>
                  </CardContent>
                </Card>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </section>
  );
}
